import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AccountComponent} from './components/account/account.component';
import {prlAuthentificationGuard} from '../../shared/services/prl-authentification-guard';
import {PrlAddContactComponent} from './components/contact/prl-add-contact/prl-add-contact.component';
import {PrlEditContactComponent} from './components/contact/prl-edit-contact/prl-edit-contact.component';
import {PrlAddDocumentComponent} from './components/document/prl-add-document/prl-add-document.component';
import {PrlContactsComponent} from './components/contact/prl-contacts/prl-contacts.component';
import {PrlPageGuard} from '../../shared/services/prl-page.guard';

const routes: Routes = [
    {
        path: 'account',
        component: AccountComponent,
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        data: {pageName: 'Account Page'}
    },
    {
        path: 'account',
        component: PrlContactsComponent,
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        data: {
            gridId: 'contacts',
            pageName: 'Account Page'
        }
    },
    {
        path: 'account/contacts/new',
        component: PrlAddContactComponent,
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        data: {
            restLink: '/account/contacts',
            className: 'com.playtech.mexos.contract.portal.account.PortalContactObj',
            threeColumns: true,
            pageName: 'Account Page'
        }
    },
    {
        path: 'account/contacts/:id',
        component: PrlEditContactComponent,
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        data: {
            restLink: '/account/contacts',
            className: 'com.playtech.mexos.contract.portal.account.PortalContactObj',
            threeColumns: true,
            pageName: 'Account Page'
        }
    },
    {
        path: 'account/documents/new',
        component: PrlAddDocumentComponent,
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        data: {
            restLink: '/account/documents',
            className: 'com.playtech.mexos.contract.portal.account.AddNewDocumentObj',
            threeColumns: true,
            pageName: 'Account Page'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PrlAccountRoutingModule {
}
